import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const ReactionsContentQuery: GraphQLTaggedNode = graphql`
	query ReactionsContentQuery($contentId: ID!) {
		content(id: $contentId) {
			nodes {
				...ReactionsContentFragment_content @relay(mask: false)
			}
		}
	}
`;
